import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import {
  Branch,
  BranchProgressState,
  BranchStatus,
  ProgressFailureReason,
} from '../../models/branch.model'
import { BaseRepository, SingleResponse } from '../base.repository'

export type MergeBranchResponse = {
  branchId: string
  eventsCreated: number
  mergeStatus: 'FAILED' | 'SUCCESS'
  message: string
  pullRequestId: string
  timestamp: string
}

export type BranchStateResponse = {
  branchId: string
  state: BranchStatus
  processState: BranchProgressState
  updatedAt: string
  processFailureReason?: ProgressFailureReason
}

export type BranchSyncResponse = {
  id: string
  status: string
  message: string
}

export type CreateBranchResponse = {
  branchId: string
  expiresIn: number
  signedUrl: string
}

@Injectable({
  providedIn: 'root',
})
export class BranchRepository extends BaseRepository<Branch> {
  public constructor() {
    super({
      resourceName: 'branches',
      defaultSorting: [{ property: 'createdAt', direction: 'asc' }],
    })
  }

  public create(item: Partial<Branch>): Observable<CreateBranchResponse> {
    return this.http.post<CreateBranchResponse>(`${this.url}`, item)
  }

  public getState(branchId: string): Observable<BranchStateResponse> {
    return this.http.get<BranchStateResponse>(`${this.url}/${branchId}/state`)
  }

  public clear(branchId: string): Observable<unknown> {
    return this.http.put(`${this.url}/${branchId}/clear`, null)
  }

  public sync(
    branchId: string
  ): Observable<SingleResponse<BranchSyncResponse>> {
    return this.http.post<SingleResponse<BranchSyncResponse>>(
      `${this.url}/${branchId}/sync`,
      null
    )
  }

  public merge(branchId: string): Observable<MergeBranchResponse> {
    return this.http.post<MergeBranchResponse>(
      `${this.url}/${branchId}/merge`,
      null
    )
  }
}
